import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdjacentType } from '@iotv/datamodel';
import { Stack, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { SingleObjectAutoSearch } from '../../generic/ObjectAutoSearch';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObjectAutoSearchWidget = (props) => {
    const [singleEntity, setSingleEntity] = useState(undefined);
    const [adjacencyType] = useState(AdjacentType.CHILD);
    const [supportedTypes] = useState([]);
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "SingleObjectAutoSearch" }), _jsx(Stack, { direction: "row", children: props.contextCustomer && (_jsx(SingleObjectAutoSearch, { contextObject: props.contextCustomer, adjacencyType: adjacencyType, objectTypeId: 'User', currentEntity: singleEntity, setCurrentEntity: setSingleEntity, supportedTypes: supportedTypes })) })] })), [props.contextCustomer, singleEntity]);
    return {
        name: 'ObjectAutoSearch',
        category: 'generic',
        component,
    };
};
